import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const FranchiseProductsTemplatesProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `FranchiseProductsTemplates/${props.franchiseProductId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `FranchiseProductsTemplates/Product/${props.productId}/${props.name}`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `FranchiseProductsTemplates/${props.franchiseProductId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);
    
    const listRecords = useCallback(async () => {
        await execute({ scope: 'list', url: `FranchiseProductsTemplates`, method: 'GET', secure: true });
    }, [execute]);  

    const listFranchiseAgentProductRecords = useCallback(async (props) => {
        await execute({ scope: 'list_franchise_agent_products', url: `FranchiseAgentProducts/FranchiseAvailable/${props.franchiseId}`, method: 'GET', secure: true });
    }, [execute]);  

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `FranchiseProductsTemplates/${props.franchiseProductId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, listFranchiseAgentProductRecords, newRecord, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useFranchiseProductsTemplatesStore = () => React.useContext(Context);
 